// Safe localStorage helpers with JSON convenience
export const safeGet = (key) => {
  try {
    return localStorage.getItem(key);
  } catch (e) {
    console.warn(`localStorage.getItem failed for ${key}`, e);
    return null;
  }
};

export const safeSet = (key, value) => {
  try {
    localStorage.setItem(key, value);
    return true;
  } catch (e) {
    console.warn(`localStorage.setItem failed for ${key}`, e);
    return false;
  }
};

export const safeRemove = (key) => {
  try {
    localStorage.removeItem(key);
    return true;
  } catch (e) {
    console.warn(`localStorage.removeItem failed for ${key}`, e);
    return false;
  }
};

export const getJSON = (key, defaultValue = null) => {
  const raw = safeGet(key);
  if (!raw) return defaultValue;
  try {
    return JSON.parse(raw);
  } catch (e) {
    console.warn(`JSON parse failed for ${key}`, e);
    return defaultValue;
  }
};

export const setJSON = (key, value) => {
  try {
    const raw = JSON.stringify(value);
    return safeSet(key, raw);
  } catch (e) {
    console.warn(`JSON stringify failed for ${key}`, e);
    return false;
  }
};

const localStorageUtils = {
  safeGet,
  safeSet,
  safeRemove,
  getJSON,
  setJSON,
};

export default localStorageUtils;
